export default {
  "ja": [
    {
      'id': 1,
      'lat': 34.690733,
      'lng': 135.561901,
      'name': '河内湖',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [1, 2, 3]
    },
    {
      'id': 2,
      'lat': 34.596940,
      'lng': 135.525047,
      'name': '難波大道',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [3]
    },
    {
      'id': 3,
      'lat': 34.596940,
      'lng': 135.525047,
      'name': '（約1400年前）',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [3],
      'newline': true
    },
    {
      'id': 4,
      'lat': 34.556000,
      'lng': 135.547224,
      'name': '竹内街道',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [3]
    },
    {
      'id': 5,
      'lat': 34.556000,
      'lng': 135.547224,
      'name': '（約1400年前）',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [3],
      'newline': true
    }
  ],
  "en": [
    {
      'id': 1,
      'lat': 34.690733,
      'lng': 135.561901,
      'name': 'Lake Kawachi',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [1, 2, 3]
    },
    {
      'id': 2,
      'lat': 34.596940,
      'lng': 135.525047,
      'name': 'Naniwa Road',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [3]
    },
    {
      'id': 3,
      'lat': 34.596940,
      'lng': 135.525047,
      'name': '(1400 years ago)',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [3],
      'newline': true
    },
    {
      'id': 4,
      'lat': 34.556000,
      'lng': 135.547224,
      'name': 'Takenouchi-kaido Road',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [3]
    },
    {
      'id': 5,
      'lat': 34.556000,
      'lng': 135.547224,
      'name': '(1400 years ago)',
      'static': true,
      'showIcon': false,
      'dependency': true,
      'dependentType': [3],
      'newline': true
    }
  ]
};


// WEBPACK FOOTER //
// ./map/js/ih/data/static-marker_mozu-furu.js